<template>
    <TabsRoot
        v-model="activeTab"
        :default-value="defaultValue">
        <TabsList
            aria-label="Выберите вкладку с описанием продукта"
            :class="[
                normalizedTabs.length < 5
                    ? 'gap-5 sm:gap-20'
                    : 'justify-between gap-5',
            ]"
            class="relative flex w-full overflow-x-auto overflow-y-hidden px-1 pb-4">
            <TabsIndicator
                class="absolute left-0 top-0 h-9 w-[--reka-tabs-indicator-size] translate-x-[--reka-tabs-indicator-position] translate-y-[1px] rounded-8 pb-[3px] transition-[width,transform] duration-[400ms] ease-in-out">
                <div class="h-full w-full rounded-8 border border-white" />
            </TabsIndicator>
            <TabsTrigger
                v-for="tab in normalizedTabs"
                :key="tab.value"
                :value="tab.value"
                class="group relative flex h-9 select-none items-center justify-center text-nowrap rounded-8 px-3 text-14/148 font-semibold text-accent-100/50 outline-none transition-colors delay-150 duration-300 hover:text-accent-100 data-[state=active]:text-white">
                <span class="relative z-20">
                    {{ tab.label }}
                </span>
                <div
                    class="absolute inset-0 z-10 size-full overflow-hidden rounded-8 opacity-0 transition-all duration-300 group-hover:opacity-100">
                    <div class="bg-noise" />
                </div>
            </TabsTrigger>
        </TabsList>
        <div class="relative mt-5 h-full lg:mt-7">
            <slot />
        </div>
    </TabsRoot>
</template>

<script setup lang="ts">
import type {
    IBaseTabsItem,
    TBaseTabAnimation,
} from '~/components/base/base-tabs/base-tabs.types'

const activeTab = defineModel({
    type: String as PropType<string>,
    required: true,
})

const props = defineProps({
    defaultValue: {
        type: String as PropType<string>,
        required: true,
    },
    tabs: {
        type: Array as PropType<(string | IBaseTabsItem)[]>,
        default: () => [],
    },
    animation: {
        type: String as PropType<TBaseTabAnimation>,
        default: 'none',
    },
})

const normalizedTabs = computed<IBaseTabsItem[]>(() => {
    return props.tabs.map((tab) => {
        if (typeof tab === 'string') {
            return {
                value: tab,
                label: tab,
            }
        }

        return tab
    })
})
</script>
